import React, { Component } from 'react';

export default function SiteFooter(props) {
	return <div className="footer">
		<div className="footer-content lang-is">© Stofnun Árna Magnússonar í íslenskum fræðum.</div>
	</div>;
}